import {ReviewFeedbackType} from "../../definitions/types";

export class ReviewFeedbackModel {
    private readonly _id: number;
    private readonly _reviewId: number;
    private readonly _ownerId: string;
    private readonly _reason?: string;
    private readonly _ip: string;
    private readonly _approved: boolean;
    private readonly _approvedBy?: string;
    private readonly _approvedOn?: Date;
    private readonly _created: Date;

    constructor(
        public readonly reviewFeedbackType: ReviewFeedbackType
    ) {
        this._id = reviewFeedbackType.id;
        this._reviewId = reviewFeedbackType.reviewId;
        this._ownerId = reviewFeedbackType.ownerId;
        this._reason = reviewFeedbackType.reason;
        this._ip = reviewFeedbackType.ip;
        this._approved = reviewFeedbackType.approved;
        this._approvedBy = reviewFeedbackType.approvedBy;
        this._approvedOn = reviewFeedbackType.approvedOn;
        this._created = reviewFeedbackType.created;
    }

    /**
     * @method id
     * @desc Returns the id of the review feedback.
     * @returns {number}
     */
    public get id(): number {
        return this._id;
    }

    /**
     * @method reviewId
     * @description Returns the id of the review the feedback is for.
     * @returns {number}
     */
    public get reviewId(): number {
        return this._reviewId;
    }

    /**
     * @method ownerId
     * @description Returns the id of the owner of the review feedback.
     * @returns {string}
     */
    public get ownerId(): string {
        return this._ownerId;
    }

    /**
     * @method reason
     * @description Returns the reason for the review feedback.
     * @returns {string | undefined}
     */
    public get reason(): string | undefined {
        return this._reason;
    }

    /**
     * @method ip
     * @description Returns the ip of the review feedback.
     * @returns {string}
     */
    public get ip(): string {
        return this._ip;
    }

    /**
     * @method approved
     * @description Returns whether the review feedback is approved.
     * @returns {boolean}
     */
    public get approved(): boolean {
        return this._approved;
    }

    /**
     * @method approvedBy
     * @description Returns the id of the user who approved the review feedback.
     * @returns {string | undefined}
     */
    public get approvedBy(): string | undefined {
        return this._approvedBy;
    }

    /**
     * @method approvedOn
     * @description Returns the date the review feedback was approved.
     * @returns {Date | undefined}
     */
    public get approvedOn(): Date | undefined {
        return this._approvedOn;
    }

    /**
     * @method created
     * @description Returns the date the review feedback was created.
     * @returns {Date}
     */
    public get created(): Date {
        return this._created;
    }
}